export { SocoConfigurationModule } from '@app/soco/configuration/configuration_module';

// DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
export { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
